const permissionsConstantEn = {
  cms: 'CMS',
  user: 'User management',
  usersApproval: 'Users approval',
  approvedDomains: 'Approved domains',
  administration: 'administration',
  systemSettings: 'System settings',
  proposalRequest: 'Proposal Requests',
  invoice: 'Slips',
  orders: 'Orders Management',
  blogs: 'Blogs',
  dashboard: 'Dashboard',
  news: 'News',
  pages: 'Pages',
  successStories: 'Success Stories',
  inventoryManagement: 'Inventory Management',
  featuredContent: 'Featured Content',
  ordersManagement: 'Orders Management',
  reports: 'Reports',
  notifications: 'Notifications',
};

export default permissionsConstantEn;
